import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal, { MaskedLine } from "../components/Reveal";
import POSTS from "../data/posts";

const Blog = () => (
  <div data-testid="blog-page" className="pt-32 lg:pt-40 pb-24 lg:pb-36 max-w-[1400px] mx-auto px-6 lg:px-10">
    <p className="text-xs uppercase tracking-[0.25em] font-semibold text-emerald mb-6">Insights</p>
    <h1 className="font-display font-semibold tracking-tighter leading-[0.95] text-6xl sm:text-7xl lg:text-8xl">
      <MaskedLine>THE POLYMER</MaskedLine>
      <MaskedLine delay={0.12}>JOURNAL<span className="text-emerald">.</span></MaskedLine>
    </h1>
    <Reveal delay={0.15}>
      <p className="text-obsidian/60 max-w-lg mt-8 leading-relaxed">
        Notes from 27 years on the moulding floor — materials, compliance and practical buying guides for packaging professionals.
      </p>
    </Reveal>

    <div className="mt-16 border-t border-line">
      {POSTS.map((post, i) => (
        <Reveal key={post.slug} delay={i * 0.06}>
          <Link
            to={`/blog/${post.slug}`}
            data-testid={`blog-card-${post.slug}`}
            className="group grid lg:grid-cols-12 gap-4 lg:gap-10 items-baseline py-10 lg:py-12 border-b border-line"
          >
            <span className="lg:col-span-1 font-display font-semibold text-4xl text-obsidian/10 tracking-tighter">
              {String(i + 1).padStart(2, "0")}
            </span>
            <div className="lg:col-span-8">
              <p className="text-[11px] uppercase tracking-[0.2em] font-semibold text-emerald mb-3">
                {post.category} · {post.readTime}
              </p>
              <h2 className="font-display font-medium text-3xl lg:text-4xl tracking-tight leading-tight group-hover:text-emerald transition-colors duration-200">
                {post.title}
              </h2>
              <p className="text-obsidian/60 mt-4 max-w-2xl leading-relaxed">{post.excerpt}</p>
            </div>
            <div className="lg:col-span-3 flex lg:justify-end">
              <span className="inline-flex items-center gap-2 text-sm font-medium border-b border-obsidian pb-1 group-hover:text-emerald group-hover:border-emerald transition-colors duration-200">
                Read article
                <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
              </span>
            </div>
          </Link>
        </Reveal>
      ))}
    </div>
  </div>
);

export default Blog;
